import styled from '@emotion/styled'

import { ApiAssetWeight, ApiMutualFundAsset, ApiSegregatedPortfolioAsset } from '@/api'
import { ModelPortfolio } from '@/modules/tradebuilder-v2/modules/03-portfolio/types'
import { getInvestmentWeightBasedOnTargetWeight } from '@/modules/tradebuilder-v2/util/get-investment-weight-based-on-target-weight'

import { Attribute, Percent, Space } from '../..'

const StyledWeightColumnDiv = styled.div`
  text-align: right;
  width: 7rem;
`

const StyledPercentWrapper = styled.div`
  width: 7rem;
  display: flex;
  justify-content: flex-end;
`

const LinkP = styled.p`
  background: none;
  border: none;
  color: var(--Red-Dark);
  cursor: pointer;
  text-decoration: underline;
  display: inline-flex;
  align-items: center;
  &:hover {
    color: var(--Graphite);
    text-decoration: none;
  }
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  margin-bottom: 0px;
`

const LinkPWrapper = styled.div`
  display: flex;
  overflow: hidden;
`
const StyledDiv = styled.div`
  background: var(--White96);
`

interface WeightsProps {
  isFundOfFunds: boolean
  onClickAsset: (asset: ApiMutualFundAsset | ApiSegregatedPortfolioAsset) => void
  portfolio: ModelPortfolio
  targetWeights: ApiAssetWeight[]
}

export const WeightsColumns = ({
  isFundOfFunds,
  onClickAsset,
  portfolio,
  targetWeights
}: WeightsProps) => (
  <>
    <StyledDiv>
      <Attribute name="Performance assets">
        {isFundOfFunds ? (
          <Space isflex>
            <StyledWeightColumnDiv>Target</StyledWeightColumnDiv>
            <StyledWeightColumnDiv>Investment</StyledWeightColumnDiv>
          </Space>
        ) : (
          'Target weights'
        )}
      </Attribute>
    </StyledDiv>
    {targetWeights?.map(x => (
      <Attribute
        key={x.asset.assetId}
        nameComponent={
          <LinkPWrapper>
            <LinkP onClick={() => onClickAsset(x.asset)}>
              {`${x.asset?.name} (${x.asset.assetId})`}
            </LinkP>
          </LinkPWrapper>
        }
      >
        {isFundOfFunds && getInvestmentWeightBasedOnTargetWeight(portfolio, x) ? (
          <Space isflex>
            <StyledPercentWrapper>
              <Percent fixed numDecimalPlaces={2} value={x.weight * 100} />
            </StyledPercentWrapper>
            <StyledPercentWrapper>
              <Percent
                fixed
                numDecimalPlaces={2}
                value={(getInvestmentWeightBasedOnTargetWeight(portfolio, x)?.weight ?? 0) * 100}
              />
            </StyledPercentWrapper>
          </Space>
        ) : (
          <Percent fixed numDecimalPlaces={2} value={x.weight * 100} />
        )}
      </Attribute>
    ))}
  </>
)
